module.exports = __webpack_public_path__ + "static/media/misterbooking.dae94dbf.png";